export default __webpack_public_path__ + "static/feature11-9986ff783f3fd11b9b3a9934ac2928b0.webp";